import { formatCurrency } from "../../../utils/formatCurrency";
import { MrrBreakdownItem } from "../../../types/unit-economics.types";

/**
 * Full-precision PLN formatter (2 decimal places) for the MRR tooltip.
 * Distinct from `formatCents` (UnitEconomicsTab.tsx), which rounds to whole
 * PLN — grosze precision matters here (e.g. 82,50 PLN, not 83 PLN).
 */
const formatCentsPrecise = (cents: number): string =>
  formatCurrency(cents / 100, "PLN", 2);

const PERIOD_LABEL: Record<string, string> = {
  quarterly: "kwart.",
  yearly: "rok",
};

/**
 * MRR tooltip label (AC-10): the monthly rate, plus — for non-monthly
 * intervals — the actual paid amount and period in parentheses. Monthly
 * payments show only the rate, since rate and paid amount coincide.
 */
export const formatMrrTooltipLabel = (
  item: Pick<MrrBreakdownItem, "monthlyCents" | "paidCents" | "interval">,
): string => {
  const monthly = `${formatCentsPrecise(item.monthlyCents)} / mies.`;
  if (item.interval === "monthly") return monthly;
  const periodLabel = PERIOD_LABEL[item.interval] ?? item.interval;
  return `${monthly} (${formatCentsPrecise(item.paidCents)} / ${periodLabel})`;
};
